// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import { Container, Header, ColumnLayout } from '@awsui/components-react';
import '@awsui/global-styles/index.css';

import MeetingForm from './MeetingForm';

const VirtualParticipant = () => {
  return (
    <Container header={<Header variant="h2">Virtual Participant</Header>}>
      <ColumnLayout columns={2}>
        <MeetingForm />
      </ColumnLayout>
    </Container>
  );
};

export default VirtualParticipant;
